import React, { ChangeEventHandler, useCallback, useContext, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ArtifactType, ContentState, SKLetterArtifact } from "../../../../../models/SKArtifact";
import { SKText } from "../../../../../models/SKText";

interface AddTextAreaFieldProps {
  name: string;
  index?: number;
  title?: string;
  note?: string;
  placeholder: string;
  height: number;
  charAllowed: number;
  value: string;
  isTitleSpace?: boolean;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  notesclass?: string;
  //onValidation: (name: string, isValid: boolean) => void;
}

export const AddTextAreaField = ({
  name,
  title,
  note,
  placeholder,
  height,
  charAllowed,
  //onValidation,
  index,
  isTitleSpace = false,
  value = "",
  notesclass = "notes-class-content",
  onChange,
}: AddTextAreaFieldProps) => {
  const { contentData, updateContentData, isEditable } = useContext(CreateArtifactContext);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  // import { useNavigationBar } from "../../../context/NavigationContext";
  const [inputValue, setInputValue] = useState(String);
  const [error, setError] = useState<string>("");
  const schema = Yup.object().shape({
    message: Yup.string().required(`Text is required!`).max(charAllowed),
  });
  const [editable, setEditable] = useState<boolean>(true);

  useEffect(() => {
    if (contentData.status === ContentState.DRAFT) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, []);

  /*   useEffect(() => {
    const validateForm = async () => {
      try {
        await schema.validate({ message: contentData.text });
        setError("");
        onValidation(name, true);
      } catch (err) {
        let error = err as Yup.ValidationError;
        setError(error.message);
        onValidation(name, false);
      }
    };
    validateForm();
  }, [contentData]); */

  const handleInput = useCallback(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, []);

  return (
    <div className="relative w-full min-w-[200px]">
      <div id="titledata" className={`flex items-center ${isTitleSpace ? "pb-[10px]" : ""}`}>
        <span>{index && <span className="content_count">{index}</span>}</span>
        {name && <span className="content_title">{title}</span>}
      </div>
      {note && <div className={notesclass}>{note}</div>}
      <div className="flex rectangle-class">
        <textarea
          name={name}
          className="rectangle-text"
          style={{ minHeight: `${height}px` }}
          placeholder={placeholder}
          ref={textareaRef}
          onInput={handleInput}
          value={value}
          onChange={onChange}
          maxLength={charAllowed}
          rows={5}
          cols={30}
          disabled={!isEditable}
        ></textarea>
      </div>
      {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
      {!error && <div className="remaining-characters">{charAllowed - (value.length ?? 0)} characters remaining.</div>}
    </div>
  );
};
